import {Vector4} from 'three';

export const DEFAULT_POSITION = [
	0.6948906183242798, 0.1967242956161499, 5.073258648735646e-7, 0.6212931871414185, 0.22521686553955078,
	-0.024087004363536835, 0.5673462152481079, 0.2831047773361206, -0.038521330803632736, 0.5307766199111938,
	0.3381573557853699, -0.051391568034887314, 0.4988502264022827, 0.3788628578186035, -0.06560245156288147,
	0.6136432886123657, 0.36340397596359253, -0.04182826355099678, 0.5879948139190674, 0.44878923892974854,
	-0.06730060279369354, 0.5733367204666138, 0.504420280456543, -0.08276277035474777, 0.5637136101722717,
	0.5479186773300171, -0.0928623303771019, 0.6601388454437256, 0.3730699419975281, -0.04513520374894142,
	0.6477749347686768, 0.46681421995162964, -0.06917751580476761, 0.6429883241653442, 0.5282996892929077,
	-0.08472905308008194, 0.642918586730957, 0.5757699608802795, -0.09473923593759537, 0.7024123668670654,
	0.36396312713623047, -0.04996153712272644, 0.7081984281539917, 0.45005136728286743, -0.07315477728843689,
	0.714698076248169, 0.5070115327835083, -0.0867847129702568, 0.7199477553367615, 0.5526862740516663,
	-0.09518611431121826, 0.7381932735443115, 0.3403705954551697, -0.05621790513396263, 0.7606501579284668,
	0.40025031566619873, -0.07994739711284637, 0.7751006484031677, 0.44385266304016113, -0.09094072878360748,
	0.7855665683746338, 0.48222047090530396, -0.09607987850904465,
];

export const TRACKED_HAND_POINTS_COUNT = DEFAULT_POSITION.length / 3;

export function handTrackingVector4Array(): Vector4[] {
	const array: Vector4[] = new Array(TRACKED_HAND_POINTS_COUNT);
	for (let i = 0; i < TRACKED_HAND_POINTS_COUNT; i++) {
		array[i] = new Vector4();
	}
	return array;
}
